@if ((alarmMask && alarmMask.textGroups?.length) || 0 > 0) {
  <div id="alarm-mask-content" class="rounded-base overflow-hidden shadow-xs">
    @for (textGroup of (alarmMask?.textGroups || []).sort(sortByOrder); track $index) {
      <h2 [attr.id]="'textGroup' + $index">
        <button
          type="button"
          class="flex cursor-pointer items-center justify-between w-full px-5 py-2.5 font-xs rtl:text-right text-body rounded-t-base border border-t-0 border-x-0 border-gray-400 hover:text-heading hover:bg-neutral-secondary-medium gap-3"
          aria-expanded="true"
          (click)="toggleTextGroupElement($index)"
          appAgentAction
          [agent]="'alarm-mask-content-toggle-' + $index"
          businessObject="alarm-mask"
          action="toggle"
        >
          <span>{{ styleToText(textGroup.style) }}</span>
          <svg
            [ngClass]="isTextGroupOpen($index) ? '' : 'rotate-180'"
            class="w-5 h-5 shrink-0 transition-transform duration-200 ease-in-out"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m5 15 7-7 7 7"
            />
          </svg>
        </button>
      </h2>
      <div
        [ngClass]="{
          'max-h-[20rem] overflow-y-auto border border-s-0 border-e-0 border-t-0 border-gray-400':
            isTextGroupOpen($index),
          'overflow-hidden max-h-0': !isTextGroupOpen($index),
        }"
        class="transition-all duration-400 ease-in-out"
      >
        <div class="px-4 py-2 md:px-5 md:py-2.5">
          @for (stringVar of (textGroup.stringVariables ?? []).sort(sortByOrder); track $index) {
            <div class="rounded-sm" [class.bg-gray-200]="$index % 2 != 0">
              @if (stringVar.stringLines?.length == 0) {
                <p class="mb-1 text-body text-amazone-orange font-xs italic">
                  <span class="p-2">translation missing</span>
                </p>
              } @else {
                @for (line of (stringVar.stringLines ?? []).sort(sortByOrder); track $index) {
                  <p class="mb-1 text-body font-mono font-xs">{{ line.text }}</p>
                }
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}
